import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  Type,
  Table,
  TableRow,
  TableHeaderCell,
  TableCell,
  TableThumbnail,
} from '@spotify-internal/encore-creator-web';
import { take } from 'lodash';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';
import { commaFormatNumber } from '../../../lib/Formatter';

import {
  LOADING,
  ERROR,
  selectNetworkTopPodcasts,
  selectNetworkTopPodcastsStatus,
} from '../../../store/selectors';
import { loadTopPodcasts } from '../../../store/networkMetadata';
import { TopPodcast, ReduxState } from '../../../types';

type Props = {
  networkId: string;
  status?: 'LOADING' | 'ERROR';
  topPodcasts?: TopPodcast[];
  loadTopPodcasts: typeof loadTopPodcasts;
} & RouteComponentProps;

export class NetworkTopPodcasts extends PureComponent<Props> {
  componentDidMount() {
    this.props.loadTopPodcasts(this.props.networkId);
  }

  renderTableRow(podcast: TopPodcast) {
    return (
      <TableRow hover key={podcast.id} data-testid="table-row">
        <TableCell truncate title={podcast.name}>
          <Link to={`/podcast/${podcast.id}`} style={{ textDecoration: 'none' }}>
            <TableThumbnail
              small
              img={podcast.artworkUrl}
              imgAlt={podcast.name}
              thumbnailTitle={podcast.name}
            />
          </Link>
        </TableCell>
        <TableCell align="right" numerical>
          {commaFormatNumber(podcast.starts)}
        </TableCell>
      </TableRow>
    );
  }

  render() {
    if (this.props.status === LOADING) {
      return <span data-qa="network-top-podcasts-loading" />;
    }

    if (this.props.status === ERROR) {
      return <span data-qa="network-top-podcasts-error" />;
    }

    if (!this.props.topPodcasts) {
      return null;
    }

    return (
      <div style={{ width: '45%' }}>
        <Type as="h1" variant={Type.heading3} condensed>
          Top podcasts
        </Type>
        <Type as="p" variant={Type.cta3} color="gray60" style={{ fontSize: '10px' }}>
          Last 7 Days
        </Type>

        <Table data-qa="network-top-podcasts-table">
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
            <TableRow>
              <TableHeaderCell>title</TableHeaderCell>
              <TableHeaderCell align="right">starts</TableHeaderCell>
            </TableRow>
          </thead>
          <tbody>
            {take(this.props.topPodcasts, 10).map(podcast => this.renderTableRow(podcast))}
          </tbody>
        </Table>
        <Link to={`/catalog`} style={{ textDecoration: 'none' }}>
          <Type
            as="p"
            variant={Type.cta3}
            color="gray60"
            condensed
            style={{ marginTop: '24px', marginBottom: '24px' }}
          >
            See Podcasts
          </Type>
        </Link>
      </div>
    );
  }
}

const selectors = createStructuredSelector<
  ReduxState,
  {
    topPodcasts: ReturnType<typeof selectNetworkTopPodcasts>;
    status: ReturnType<typeof selectNetworkTopPodcastsStatus>;
  }
>({
  topPodcasts: selectNetworkTopPodcasts,
  status: selectNetworkTopPodcastsStatus,
});

const actions = {
  loadTopPodcasts,
};

export const NetworkTopPodcastsWithRouter = withRouter(
  connect(selectors, actions)(NetworkTopPodcasts),
);
